import * as React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

import s from './styles.module.css'

const Card = ({ to, text, image }) => (
  <Link key={to} to={to} className={s.card}>
    <h3 className={s.link}>{text}</h3>
    <Img
      outerWrapperClassName={s.cardImage}
      className={s.cardImage}
      sizes={image.sizes}
    />
  </Link>
)

export default Card



// WEBPACK FOOTER //
// ./src/components/Card/index.js